import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import CustomParagraphComponent from "./Facilities/CustomParagraphComponent";
import GetInTouchFooter from "./GetInTouchFooter";
import axiosStrapiInstance, { baseUrl } from "../axiosStrapi";
import Loader from "./custom/Loader";
import { toast } from "react-toastify";
import CustomContent from "./custom/CustomContent";
import CustomHeading from "./custom/CustomHeading";
import { headerImages } from "../utils/constants";
import { Helmet } from "react-helmet";

const Activities = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getActivities() {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        "/api/page-contents?filters[pageType][$eq]=Activities&populate=*&sort=pageTypeId:asc"
      );
      const result = response?.data?.data?.map((item) => ({
        ...item,
        images: item?.images?.map((item) => `${item?.url}`),
      }));
      setActivities(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }

  useEffect(() => {
    getActivities();
    const timer = setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
      <Helmet>
        <title>
          Activities at Mother's Pride - Enriching Every Child's Day
        </title>
        <meta
          name="description"
          content="Explore the range of activities at Mother's Pride Preschool designed to develop creativity, confidence, and curiosity in young minds."
        />
        <meta
          name="keywords"
          content="annual school calendar, academic calendar preschool, yearly schedule, important school dates, event calendar"
        />
      </Helmet>
      <div>
        <div>
          <img
            src={
              window.innerWidth < 450
                ? window.innerWidth < 800
                  ? headerImages.tabActivitiesHeaderImg
                  : headerImages.mobileActivitiesHeaderImg
                : headerImages.activitiesHeaderImg
            }
            alt="positive parenting"
            className="overflow-x-hidden w-[100vw] sm:h-[300px] lg:h-[420px] "
          />
        </div>

        <div className="px-[4%] 2xl:px-[6%] flex flex-col mt-[20px] sm:mt-[60px] gap-10 ">
          {/* main img */}
          <div className="flex flex-col gap-3">
            <div className="flex w-full flex-row items-end lg:mt-0 mt-5 gap-1">
              <CustomHeading
                text={"Activities at mother"}
                spanText={"'"}
                spanTextColor="#383838"
                thirdTextColor="#383838"
                secondFontStyle="font-Lato"
                thirdText={"s Pride"}
                textSize="58px"
                heartPosition="absolute"
                textColor="#383838"
                showHeart={window.innerWidth > 450 && true}
                heartMarginLeft={window.innerWidth < 450 ? "2%" : "50%"}
                heartHeight="40px"
                heartWidth="40px"
                smTextSize="32px"
              />
              <div className="inline">
                <CustomContent
                  textColor="#d31c4f"
                  text={"//PreSchool"}
                  textSize="42px"
                  smTextSize="20px"
                  leading="52px"
                  marginTop={window.innerWidth < 450 ? "-32px" : "0"}
                />
              </div>
            </div>
            <CustomContent
              textColor="#111010"
              text={
                " Preschool days are the most important phase for a child’s emotional development; it’s when the child builds his/her confidence, self esteem and creative expression. To help our children excel in life skills, we organize regular activities where our Prideens across branches come together and mesmerize everyone with their confidence and charisma. Stage exposure bolsters children's creative expression, self-esteem and interpretation skills – all of which can go a long way in empowering them."
              }
              textSize="24px"
              leading="38px"
              textAlign="justify"
              smTextSize="18px"
            />
          </div>

          {/* all the divs */}
          <div className="flex flex-col gap-[50px] ">
            {loading ? (
              <Loader />
            ) : (
              activities?.map((item, index) => (
                <CustomParagraphComponent
                  key={index}
                  heading={item?.heading}
                  content={item?.content}
                  images={item?.images}
                />
              ))
            )}
          </div>
          <GetInTouchFooter marginX={"0%"} />
          <div>
            <Footer marginX={"0%"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activities;
